import { createStyles, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { Button, MdSpace, SmSpace } from 'm2m.components';
import React from 'react';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    iconWrapper: {
      width: '112px',
      height: '112px',
      borderRadius: '50%',
      backgroundColor: theme.palette.primary.main,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    icon: {
      width: '40px',
      height: '40px',
    },
  })
);

interface FinishedSignProps {
  description: string;
  redirectRoute: string;
  buttonText?: string;
}

type Props = FinishedSignProps;

const FinishedSign: React.FC<Props> = (props) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Grid container direction="column" justify="center" alignItems="center">
      <MdSpace />
      <div className={classes.iconWrapper}>
        <CheckCircleIcon className={classes.icon} color="secondary" />
      </div>
      <SmSpace />
      <Typography variant="h3">{props.description}</Typography>
      <MdSpace />
      <Button onClick={() => history.push(props.redirectRoute ?? '/')} variant="contained" color="primary">
        {props.buttonText ?? 'Voltar para a página inicial'}
      </Button>
      <MdSpace />
    </Grid>
  );
};

export default FinishedSign;
